import styled from 'styled-components'
import { styled as muiStyled } from '@mui/material/styles'
import ExpandMore from '@mui/icons-material/ExpandMore'

export const ClinicTimeSlotSelectionContainer = muiStyled('div')(
  ({ theme }) => `
    width: 130px;
  `,
)

export const ScheduleInputContainer = muiStyled('div')(
  ({ theme }) => `
    width: 100%;
  `,
)
export const ScheduleTitleInputContainer = muiStyled('div')(
  ({ theme }) => `
    width: 100%;
    // @media(min-width: 768px){
    //   width: 80%;
    // }
    // @media(min-width: 992px){
    //   width: 60%;
    // }
  `,
)
export const CollapseIcon = muiStyled(ExpandMore, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})(
  ({ theme, collapsed }) => `
    transform: ${collapsed ? 'rotate(0deg)' : 'rotate(180deg)'};
        transition: all .4s cubic-bezier(0.42, 0.03, 0.16, 0.94);
`,
)

export const ReactSelectCustomContainer = muiStyled('div')(
  ({
    theme,
    invalid,
    customInvalidColor = theme.palette.error.main,
    customValidColor = '#ebebebeb',
    showBorder = false,
  }) => `
  padding: 2px;
  border-radius: 6px;
background: ${invalid ? customInvalidColor : customValidColor};

> div {
  display: flex;
}
`,
)

export const ScheduleTabContainer = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;

  ::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`
